import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Equipamento } from '../classes/Equipamento';

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService {

  constructor(private http: HttpClient) { }

  getEquipamentos(): Observable<any>{
    return this.http.get(`${environment.apiURL}/equipamento/Ativos`)
  }

  getTodosEquipamentos(): Observable<any>{
    return this.http.get(`${environment.apiURL}/equipamento/ListarTodos`)
  }
  getEquipamento(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/equipamento/${id}`)
  }

  postEquipamento(equipamento: Equipamento): Observable<any>{
    return this.http.post(`${environment.apiURL}/equipamento`, equipamento);
  }

  putEquipamento(id: number, equipamento: Equipamento): Observable<any>{
    return this.http.put(`${environment.apiURL}/equipamento/${id}`, equipamento);
  }

  deleteEquipamento(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/equipamento/${id}`);
  }

  duplicar(ids: number[]): Observable<any>{
    return this.http.post(`${environment.apiURL}/equipamento/duplicar`, ids);
  }

  inativar(ids: number[]): Observable<any>{
    return this.http.put(`${environment.apiURL}/equipamento/inativar`, ids);
  }

  deleteEquipamentos(ids: number[]): Observable<any>{
    const params = ids.map(id => `ids=${id}`).join('&');
    return this.http.delete(`${environment.apiURL}/equipamento?${params}`);
  }
}
